import React from 'react'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
const Page404 = props => (
  <>
    <h1>
      <FormattedMessage id={'page404.title'} />
    </h1>
    <Link to={'/'}>
      <FormattedMessage id={'page404.linkText'} />
    </Link>
  </>
)
export default Page404
